import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'dc-inline-svg',
	template: ` <div class="svg-container" [attr.data-fill]="fill" [attr.data-hover]="hover" [innerHtml]="svg"></div> `,
	styleUrls: ['./inline-svg.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class InlineSvgComponent implements OnInit {
	@Input()
	image: string;

	@Input()
	fill: string;

	@Input()
	hover: boolean;

	svg: SafeHtml;

	constructor(private sanitizer: DomSanitizer) { }

	ngOnInit(): void {
		this.svg = this.sanitizer.bypassSecurityTrustHtml(this.image);
	}
}
